__turbopack_context__.v({
  "accordion-body": "accordion-module-scss-module__1AH4hG__accordion-body",
  "accordion-body-animation": "accordion-module-scss-module__1AH4hG__accordion-body-animation",
  "accordion-body-hidden": "accordion-module-scss-module__1AH4hG__accordion-body-hidden",
  "accordion-body-show": "accordion-module-scss-module__1AH4hG__accordion-body-show",
  "accordion-container": "accordion-module-scss-module__1AH4hG__accordion-container",
  "accordion-separator": "accordion-module-scss-module__1AH4hG__accordion-separator",
  "accordion-title-container": "accordion-module-scss-module__1AH4hG__accordion-title-container",
  "accordion-title-container-content": "accordion-module-scss-module__1AH4hG__accordion-title-container-content",
  "accordion-title-container-textContainer": "accordion-module-scss-module__1AH4hG__accordion-title-container-textContainer",
  "accordion-title-expand": "accordion-module-scss-module__1AH4hG__accordion-title-expand",
  "accordion-title-expand-collapse": "accordion-module-scss-module__1AH4hG__accordion-title-expand-collapse",
  "accordion-title-expand-show": "accordion-module-scss-module__1AH4hG__accordion-title-expand-show",
});
